// extracted by mini-css-extract-plugin
module.exports = {"ratingStars":"_1nZbwZC9_zqUHFpPPqhhhS","box":"WnPrG00dY3QLM5H1ukRXL","star":"_1SI3Rvq2RSnYzFumg_GojH","result":"_2Pxjr50jxmaS-WGVfjItr8","msgError":"t7yYgu2l2EZNJTUleoB4U"};